import {
  createSlice,
  createEntityAdapter,
  createReducer,
} from "@reduxjs/toolkit";

export const initialState = {
  static: {
    initialScore: {
      Exceptional: { win: 0, lose: 0, tie: 0, total: 0 },
      Genius: { win: 0, lose: 0, tie: 0, total: 0 },
      Intelligent: { win: 0, lose: 0, tie: 0, total: 0 },
      Average: { win: 0, lose: 0, tie: 0, total: 0 },
      Stupid: { win: 0, lose: 0, tie: 0, total: 0 },
      "Other Human": { win: 0, lose: 0, tie: 0, total: 0 },
    },
    initial: [new Array(9).fill(undefined)],
    lines: [
      [0, 1, 2],
      [3, 4, 5],
      [6, 7, 8],
      [0, 3, 6],
      [1, 4, 7],
      [2, 5, 8],
      [0, 4, 8],
      [2, 4, 6],
    ],
  },
};

const staticSlice = createSlice({
  initialState: initialState.static,
  name: "staticSlice",
  extraReducers: (builder) => {
    builder.addDefaultCase((state, action) => state);
  },
});

export const staticReducer = staticSlice.reducer;
